import {useQuery} from '@tanstack/react-query';
import {getCapacityProviders} from 'App/api/integrations/typed';
import {CAPACITY_PROVIDERS_QUERY_KEY} from 'App/data-hooks/queryKeys';

const useCapacityProviders = () => {
  const capacityProvidersQuery = useQuery([CAPACITY_PROVIDERS_QUERY_KEY], async () => {
    const response = await getCapacityProviders();
    return response.data.filter((currentCarrier) => !currentCarrier?.modes?.includes('LTL'));
  });

  return capacityProvidersQuery;
};

export default useCapacityProviders;
